var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"about-nav"},[_c('div',{staticClass:"pc-container about-inner"},_vm._l((_vm.tabs),function(item){return _c('button',{key:item,class:{ active: item === '公司新闻' },on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }